import React, {  useState } from 'react';
import IsMobilecheck from '../../utils/ismobile';


export default function ReadContentsSection({ title = 'CONTENTS SECTION', items = [], className = '' }) {
  const [activeItem, setActiveItem] = useState('');
  const isMobile = IsMobilecheck();

  const handleItemClick = (id) => {
    if (activeItem === id) return;
    setActiveItem(id);
    if (typeof window !== 'undefined') {
      window.history.pushState(null, '', `${window.location.pathname}#${id}`);
      document.getElementById(id)?.scrollIntoView();
    }
  };

  return (
    <div className={` ${className} ${isMobile ? 'read_contents-section--mobile' : 'read_contents-section'}`}>
      {/* <h2 className="read_contents-section__title">{title}</h2> */}
      <div className="read_contents-section__list">
        {items?.map((item) => (
          <div
            key={item?.id}
            onClick={() => handleItemClick(item.id)}
            className={`read_contents-section__item 
              ${item?.id === activeItem ? 'read_contents-section__item--highlighted' : ''} 
              ${item?.id === activeItem ? 'read_contents-section__item--underlined' : ''}`}
          >
            {item?.title}
          </div>
        ))}
      </div>
    </div>
  );
}
